// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./src/shared/imports/polyfills.ts");
__webpack_require__("./src/bootstrap.ts");
__webpack_require__("./src/client/dependency-injection/ServiceDefinitions.ts");
__webpack_require__("./src/testing/ServicesOverrides.ts");
var __webpack_exports__ = __webpack_require__("./src/client/st/ST.ts");
